"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgbaToStr = exports.rgbToStr = void 0;
var tslib_1 = require("tslib");
var rgbToStr = function (_a) {
    var _b = tslib_1.__read(_a, 3), r = _b[0], g = _b[1], b = _b[2];
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
};
exports.rgbToStr = rgbToStr;
var rgbaToStr = function (_a) {
    var _b = tslib_1.__read(_a, 4), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
};
exports.rgbaToStr = rgbaToStr;
